export default __webpack_public_path__ + "static/media/2c814f26-9d3c-4b66-ae54-003fe4db2cb4.d0628d27.jpeg";